/**
 * Info texts maintained on the plugin settings page (AF Settings → Info-Texte),
 * passed to the frontend via wp_localize_script. Empty if not maintained.
 */
const infoTexts = (typeof options !== 'undefined' && options.infoTexts) ? options.infoTexts : {};

export default infoTexts;
